import { Dialog, DialogProps, styled } from '@mui/material';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';

import CloseIcon from 'app/components/Icons/CloseIcon';

export const BootstrapDialog = styled(Dialog)(() => ({
  '& .MuiDialogContent-root': {
    padding: '0px 32px 32px 32px',
  },
  '& .MuiDialogActions-root': {
    padding: '32px',
  },
}));

export interface DialogContentBoxProps extends DialogProps {
  open: boolean;
  title?: string;
  children: React.ReactNode;
  closeIcon?: boolean;
  handleClose: () => void;
}
export default function CustomDialog({
  open,
  title,
  children,
  handleClose,
  closeIcon = true,
  ...props
}: DialogContentBoxProps) {
  return (
    <BootstrapDialog onClose={handleClose} open={open} {...props}>
      {title && <DialogTitle sx={{ m: 0, padding: '32px 32px 15px 32px' , fontWeight : 600 }}>{title}</DialogTitle>}
      {closeIcon && (
        <Button
          color={'secondary'}
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 32,
            top: 32,
            minWidth: '36px',
            width: '36px',
          }}
        >
          <CloseIcon />
        </Button>
      )}
      {children}
    </BootstrapDialog>
  );
}
